import { render } from "./StaffDetailsPage.vue?vue&type=template&id=b0d3f432&scoped=true"
import script from "./StaffDetailsPage.vue?vue&type=script&lang=js"
export * from "./StaffDetailsPage.vue?vue&type=script&lang=js"

import "./StaffDetailsPage.vue?vue&type=style&index=0&id=b0d3f432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d3f432"]])

export default __exports__